if (!customElements.get('product-grid')) {
  customElements.define(
    'product-grid',
    class ProductGrid extends HTMLElement {
      constructor() {
        super();
        this.productGrid = null;

        this.mobileColsForm = null;
        this.desktopColsForm = null;

        this.mobileColsRadioButtons = null;
        this.desktopColsRadioButtons = null;

        this.numOfDesktopCols = 4;
        this.numOfMobileCols = 2;

        this.handleMobileClick = this.handleMobileClick.bind(this);
        this.handleDesktopClick = this.handleDesktopClick.bind(this);

        this.handleTransitionEnd = this.handleTransitionEnd.bind(this);

        this.mql = window.matchMedia('(max-width: 989px)');
        this.handleMqlChange = this.handleMqlChange.bind(this);


        this.sizeDefinitions = {
          1: '(min-width: 990px) calc(100vw - 32px), calc(100vw - 24px)',
          2: '(min-width: 990px) calc((100vw - 40px) / 2), calc((100vw - 32px) / 2)',
          3: '(min-width: 990px) calc((100vw - 48px) / 3), calc((100vw - 40px) / 3)',
          4: '(min-width: 990px) calc((100vw - 56px) / 4), calc((100vw - 48px) / 4)',
        }
      }

      connectedCallback() {
        this.mobileColsForm = this.querySelector('.collection__grid-view-mobile');
        this.desktopColsForm = this.querySelector('.collection__grid-view-desktop');

        this.productGrid = this.querySelector('#product-grid');

        if (this.mobileColsForm) {
          this.mobileColsRadioButtons = this.mobileColsForm.querySelectorAll('input[type="radio"]');

          const mobileColsCount = localStorage.getItem('mobileCols');

          if (mobileColsCount) {
            this.numOfMobileCols = parseInt(mobileColsCount);

            for(const el of this.mobileColsRadioButtons) {
              if (parseInt(el.value) === this.numOfMobileCols) {
                el.checked = true;
                break;
              }
            }
          }

          this.mobileColsForm.addEventListener('change', this.handleMobileClick);
        }

        if (this.desktopColsForm) {
          this.desktopColsRadioButtons = this.desktopColsForm.querySelectorAll('input[type="radio"]');

          const desktopColsCount = localStorage.getItem('desktopCols');

          if (desktopColsCount) {
            this.numOfDesktopCols = parseInt(desktopColsCount);

            for(const el of this.desktopColsRadioButtons) {
              if (parseInt(el.value) === this.numOfDesktopCols) {
                el.checked = true;
                break;
              }
            }
          }

          this.desktopColsForm.addEventListener('change', this.handleDesktopClick);
        }

        this.renderLayout(this.mql.matches);

        this.classList.remove('loading');

        this.addEventListener('transitionend', this.handleTransitionEnd);


        // React when crossing 990px boundary
        this.mql.addEventListener('change', this.handleMqlChange);
      }

      disconnectedCallback() {
        if (this.mobileColsForm) {
          this.mobileColsForm.removeEventListener('change', this.handleMobileClick);
        }
        if (this.desktopColsForm) {
          this.desktopColsForm.removeEventListener('change', this.handleDesktopClick);
        }

        this.mql.removeEventListener('change', this.handleMqlChange);

        this.removeEventListener('transitionend', this.handleTransitionEnd);
      }

      get imgs() {
        return this.productGrid.querySelectorAll('img');
      }

      handleMobileClick(event) {
        this.classList.add('loading');
        const cols = parseInt(event.target.value);
        if (![1, 2].includes(cols)) return;
        this.numOfMobileCols = cols;

        localStorage.setItem('mobileCols', this.numOfMobileCols);
      }

      handleDesktopClick(event) {
        this.classList.add('loading');
        const cols = parseInt(event.target.value);
        if (![2, 3, 4].includes(cols)) return;
        this.numOfDesktopCols = cols;

        localStorage.setItem('desktopCols', this.numOfDesktopCols);
      }

      handleTransitionEnd(event) {
        if (event.target === this && event.propertyName === 'opacity' && event.target.classList.contains('loading')) {
          this.renderLayout(this.mql.matches);

          this.classList.remove('loading');
        }
      }

      renderLayout(isMobile) {
        if (isMobile) {
          this.imgs.forEach((img) => {
            const sizesValue = this.sizeDefinitions[this.numOfMobileCols];
            if (sizesValue) {
              img.setAttribute('sizes', sizesValue);
            }
          });

          this.productGrid.setAttribute('data-mobile-column-count', this.numOfMobileCols);

          if (this.numOfMobileCols === 1) {
            this.classList.add('reverse-hover-images');
          } else {
            this.classList.remove('reverse-hover-images');
          }
        } else {
          this.imgs.forEach((img) => {
            const sizesValue = this.sizeDefinitions[this.numOfDesktopCols];
            if (sizesValue) {
              img.setAttribute('sizes', sizesValue);
            }
          });

          this.productGrid.setAttribute('data-desktop-column-count', this.numOfDesktopCols);

          if (this.numOfDesktopCols === 2) {
            this.classList.add('reverse-hover-images');
          } else {
            this.classList.remove('reverse-hover-images');
          }
        }
      }

      handleMqlChange(event) {
        this.renderLayout(event.matches);
      }
    }
  );
}
